// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cert-img[data-v-1b7d5998]{padding:15px}.cert-img .img[data-v-1b7d5998]{border-radius:5px;width:100%;object-fit:scale-down}.load-tip[data-v-1b7d5998]{color:grey;text-align:center;margin-top:30%}", ""]);
// Exports
module.exports = exports;
